<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="permissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-clock"></em></span>
    {{ "ExpiredControl.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="block">
            <div class="p-fluid grid">
              <!-- 廠區 (Required, Single Select) -->
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  <span class="requiredStart">*</span>{{ "ExpiredControl.Search.Plant" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="plant"
                    [options]="plantOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [showClear]="true"
                    [ngClass]="{
                      'ng-invalid ng-dirty': (submitted || submittedSend311) && searchForm.controls.plant.errors
                    }"
                  ></p-dropdown>
                </div>
              </div>
              <!-- 庫別 (Required, Single Select) -->
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  <span class="requiredStart">*</span>{{ "ExpiredControl.Search.SpecLocType" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="specLocType"
                    [options]="storageLocationOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [showClear]="true"
                    [filter]="true"
                    filterBy="label"
                    [ngClass]="{
                      'ng-invalid ng-dirty': (submitted || submittedSend311) && searchForm.controls.specLocType.errors
                    }"
                  ></p-dropdown>
                </div>
              </div>
              <!-- 料號 (Free Keyin) -->
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "ExpiredControl.Search.SKU" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="sku"
                    (keydown.enter)="$event.preventDefault()"
                  />
                </div>
              </div>
              <!-- 狀態 (Required, Single Select) -->
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  <span class="requiredStart">*</span>{{ "ExpiredControl.Search.ExpiredStatus" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="expiredStatus"
                    [options]="statusOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                    [showClear]="true"
                    [ngClass]="{
                      'ng-invalid ng-dirty': (submitted || submittedSend311) && searchForm.controls.expiredStatus.errors
                    }"
                  ></p-dropdown>
                </div>
              </div>
              <!-- SAP帳號 (Required for Send311, Free Keyin) -->
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "ExpiredControl.Search.NameOfPerson" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="nameOfPerson"
                    maxlength="12"
                    (keydown.enter)="$event.preventDefault()"
                    [ngClass]="{
                      'ng-invalid ng-dirty': submittedSend311 && !searchForm.controls.nameOfPerson.value
                    }"
                  />
                </div>
              </div>
              <!-- Cost Center (Required for Send311, Free Keyin) -->
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "ExpiredControl.Search.CostCenter" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="costCenter"
                    maxlength="10"
                    (keydown.enter)="$event.preventDefault()"
                    [ngClass]="{
                      'ng-invalid ng-dirty': submittedSend311 && !searchForm.controls.costCenter.value
                    }"
                  />
                </div>
              </div>
              <!-- Employee ID 工號 (Required for Send311, Free Keyin) -->
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "ExpiredControl.Search.EmployeeID" | translate }}
                </div>
                <div class="block">
                  <input
                    pInputText
                    type="text"
                    formControlName="employeeID"
                    maxlength="12"
                    (keydown.enter)="$event.preventDefault()"
                    [ngClass]="{
                      'ng-invalid ng-dirty': submittedSend311 && !searchForm.controls.employeeID.value
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                type="button"
                (click)="searchBtnClick()"
                label="{{ 'Common.Button.Search' | translate }}"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                (click)="resetBtnClick()"
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-2"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                (click)="send311BtnClick()"
                label="{{ 'ExpiredControl.Button.Send311' | translate }}"
                class="ml-2"
                [disabled]="searchForm.controls.expiredStatus.value === '30' || searchForm.controls.expiredStatus.value === '60'"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #dataTable
        [dataKey]="'sku'"
        [defaultColumns]="columns"
        [loading]="isLoading"
        [value]="searchResults"
        [selectable]="true"
        [(selectedRows)]="selectedRows"
        [isShowCreateRowFunction]="false"
        [expandable]="true"
      >
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
          <laas-data-table
            [selectable]="false"
            [dataKey]="'uId'"
            [value]="rowData.details"
            [defaultColumns]="detailColumns"
            [paginator]="false"
          >
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <td *ngFor="let col of columns">
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </td>
            </ng-template>
          </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
